/* src/app/feature-modules/lessons/components/lesson-list/lesson-list.component.css */
.search-results {
  height: 25rem;
  overflow: scroll;
  overflow-x: hidden;
}
.table-head-grade {
  width: 100px;
}
.table-head-empty-label {
  width: 60px;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgb(158, 158, 158);
}
::-webkit-scrollbar-thumb:hover {
  background: rgb(158, 158, 158);
}
/*# sourceMappingURL=lesson-list.component.css.map */
